<template>
  <div class="container page-wrap">
    <div v-if="!isMobileScreenExclude768 || $route.name === 'Profile'" class="main-content profile-page">
      <div class="container">
        <div class="profile-cnt">
          <div class="menu-wrap">
            <ProfileMenu />
          </div>
          <RouterView />
        </div>
      </div>
    </div>

    <div v-else class="page-wrap">
      <div class="main-content profile-data-page">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <RouterView />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProfileMenu from '@/components/partials/profile/ProfileMenu';

export default {
  name: 'ProfilePage',
  components: {
    ProfileMenu,
  },
  computed: {
    ...mapState(['isMobileScreenExclude768']),
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.container {
  @media (max-width: vars.$tablet-break-point) {
    padding: 0 15px !important;
  }
}

.padding {
  @media (max-width: vars.$tablet-break-point) {
    overflow-x: hidden !important;
    padding: 0 15px;
  }
}

.profile-data-page {
  @media (max-width: vars.$tablet-break-point) {
    align-items: baseline;
  }
}
</style>
